<template>
  <v-tooltip :text="text" location="end">
    <template #activator="{ props: tooltipProps }">
      <v-btn
        v-bind="tooltipProps"
        color="surface"
        :active="highlight"
        rounded="sm"
        density="compact"
        icon
        :aria-label="text"
        style="width: 40px; min-height: 40px"
        @click="emit('click')"
      >
        <v-badge v-if="badge" dot color="error">
          <v-icon :icon="icon" />
        </v-badge>

        <v-icon v-else :icon="icon" />
      </v-btn>
    </template>
  </v-tooltip>
</template>

<script setup lang="ts">
const {
  icon,
  badge = false,
  highlight = false,
  text = undefined,
} = defineProps<{
  icon: string
  badge?: boolean
  highlight?: boolean
  text?: string
}>()

const emit = defineEmits<{
  (e: "click"): void
}>()
</script>
